import { slideBgImageStyle } from '@/lib/deck/bg-helpers';
import type { SlideBg } from '@/lib/deck/types';

interface SlideFrameProps {
  id?: string;
  bg?: SlideBg;
  bgColor?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Deck slide frame — background image via <img> (no Next.js Image).
 */
export function SlideFrame({ id, bg, bgColor, className, children }: SlideFrameProps) {
  const fill = bg?.color ?? bgColor;
  const frameStyle: React.CSSProperties = fill ? { backgroundColor: fill } : {};
  const fit = bg?.objectFit === 'contain' ? 'object-contain' : 'object-cover';
  const imgStyle = slideBgImageStyle(bg);

  return (
    <div
      id={id}
      className={`relative flex min-h-screen snap-start flex-col overflow-hidden ${className ?? ''}`}
      style={frameStyle}
    >
      {bg?.src ? (
        <img
          src={bg.src}
          alt=""
          className={`absolute inset-0 h-full w-full ${fit}`}
          style={imgStyle}
          aria-hidden
        />
      ) : null}
      {children}
    </div>
  );
}
